/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Two_Factor_Code_InvalidInputs */

const nl_auth_api_errors_two_factor_code_invalid = /** @type {(inputs: Auth_Api_Errors_Two_Factor_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldige twee-factor authenticatie code`)
};

/**

* @param {Auth_Api_Errors_Two_Factor_Code_InvalidInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_two_factor_code_invalid = /** @type {((inputs?: Auth_Api_Errors_Two_Factor_Code_InvalidInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Two_Factor_Code_InvalidInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_two_factor_code_invalid(inputs)
});
export { auth_api_errors_two_factor_code_invalid as "auth.api_errors.two_factor_code_invalid" }